import { useCallback, useEffect, useState } from 'react'

import { singleAdThumbnailHeight } from '../../FacebookSingleMediaAdPreview/FacebookSingleMediaAdFooter/styles'
import SkeletonAdMediaThumbnail from '../../reusablePreviewComponents/SkeletonAdMediaThumbnail'

import useStyles from './styles'

const FacebookExistingPostMediaThumbnail = ({ mediaUrl = '', isInProgress = false }) => {
  const [isMediaLoaded, setIsMediaLoaded] = useState(false)

  const classes = useStyles({ height: isMediaLoaded ? 'auto' : singleAdThumbnailHeight })

  const handleMediaSuccessfullyLoaded = useCallback(() => {
    setIsMediaLoaded(true)
  }, [])

  // We need isMediaLoaded to define thumbnail height.
  // When user delete media clear isMediaLoaded
  useEffect(() => {
    if (!mediaUrl) {
      setIsMediaLoaded(false)
    }
  }, [mediaUrl])

  if (!mediaUrl) {
    return (
      <SkeletonAdMediaThumbnail
        isInProgress={isInProgress}
        mediaPreviewHeight={singleAdThumbnailHeight}
        className={classes.adMedia}
      />
    )
  }

  return (
    <div className={classes.adMedia}>
      <img onLoad={handleMediaSuccessfullyLoaded} src={mediaUrl} alt="Media preview" />
    </div>
  )
}

export default FacebookExistingPostMediaThumbnail
